import * as Yup from "yup";

export const CREATE_PARTICIPANT_INITIAL_VALUES = {
  name: "",
  username: "",
  platforms: [],
};

export const createParticipantValidationSchema = Yup.object({
  name: Yup.string().trim().required("Name is required"),
  username: Yup.string().trim().required("Username/Email is required"),
  platforms: Yup.array()
    .min(1, "Please select at least one platform")
    .required("Platform is required"),
});
